export default function setPublicPath(path: string): string {
    if (process.env.IS_WEBPACK) {
        __webpack_public_path__ = path;
    }
    return path;
}
